﻿import * as React from "react";
import {
    ApplicationGroups,
    Applications,
    IApplication,
    IApplicationGroup,
    ISearchResult,
    Notes,
    SearchField,
    SearchResults,
} from "./ReleaseNotes";
import axios from "axios";
import { Box } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

interface IWrapper {
    groups: IApplicationGroup[];
    applications: IApplication[];
}

// TODO: this code is currently unused, if it starts being used it would be nice to
// convert into a functional component.

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IProps {}

interface IState {
    groups: IApplicationGroup[];
    applications: IApplication[];
    collapseGroups: boolean;
    searchText: string;
    searchResults: ISearchResult[];
    selectedGroup?: number;
    selectedApplication?: number;
}

export class ReleaseNotesRoot extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            applications: [],
            collapseGroups: false,
            groups: [],
            searchResults: [],
            searchText: ``,
            selectedApplication: null,
            selectedGroup: null,
        };

        // Get groups and applications
        axios
            .get(`${ROOT_URL}/GetGroupsAndApplications`, {})
            .then((response) => {
                const data = response.data as IWrapper;

                if (data?.[0] !== null) {
                    this.setState({
                        applications: data.applications,
                        groups: data.groups,
                    });

                    this._setInitialConfig();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private readonly _setInitialConfig = (): void => {
        if (this.state.groups.length > 0) {
            const filteredApplications = this.state.applications.filter(
                    (n) => n.groupID === this.state.groups[0].groupID,
                ),
                selectedGroup = this.state.groups[0].groupID;

            if (filteredApplications.length > 0) {
                this.setState({
                    selectedGroup,
                });
                this._handleApplicationClick(
                    filteredApplications[0].applicationID,
                );
            } else {
                this.setState({
                    selectedApplication: null,
                    selectedGroup,
                });
            }
        }
    };

    private readonly _handleGroupClick = (groupID): void => {
        const filteredApplications = this.state.applications.filter(
            (n) => n.groupID === groupID,
        );

        if (filteredApplications?.[0] != null) {
            this.setState({
                collapseGroups: false,
                selectedGroup: groupID,
            });

            this._handleApplicationClick(filteredApplications[0].applicationID);
        } else {
            this.setState({
                collapseGroups: false,
                selectedApplication: null,
                selectedGroup: groupID,
            });
        }
    };

    private readonly _handleApplicationClick = (applicationID): void => {
        const application = this.state.applications.filter(
            (app) => app.applicationID === applicationID,
        );

        // User reading new release notes
        if (application != null && !application[0].readLatest) {
            // Update DB
            axios
                .post(`${ROOT_URL}/UpdateReadLatest`, {
                    applicationID,
                })
                .then(() => {
                    // TODO: See if this .then can be removed, can't see why not.
                    // Do nothing
                })
                .catch((error) => {
                    console.log(error);
                });

            this.setState((prevState) => {
                // Update frontend
                const applications = prevState.applications.map((app) =>
                        app.applicationID === applicationID
                            ? Object.assign(app, { readLatest: true })
                            : app,
                    ),
                    unreadReleases = prevState.applications.filter(
                        (app) =>
                            app.groupID === application[0].groupID &&
                            !app.readLatest,
                    );

                let groups;

                if (unreadReleases === null || unreadReleases.length === 0) {
                    groups = prevState.groups.map((group) =>
                        group.groupID === application[0].groupID
                            ? Object.assign(group, { readLatest: true })
                            : group,
                    );
                } else {
                    groups = prevState.groups;
                }

                return {
                    applications,
                    groups,
                };
            });
        }

        this.setState({
            selectedApplication: applicationID,
        });
    };

    private readonly _updateSearchText = (e): void => {
        this.setState({
            searchText: e.target.value,
        });
    };

    private readonly _clearSearchText = (): void => {
        this.setState({
            searchText: ``,
        });
    };

    private readonly _updateSearchResults = (
        searchResults: ISearchResult[],
    ): void => {
        this.setState({
            searchResults,
        });
    };

    private readonly _handelCollapseButtonClick = (): void => {
        this.setState({
            collapseGroups: true,
            searchText: ``,
        });
    };

    private readonly _handelUncollapseButtonClick = (): void => {
        this.setState({
            collapseGroups: false,
        });
    };

    render(): React.ReactElement {
        return (
            <div className={`releasenotes-rootcontainer`}>
                <div className={`relasenotes-header greybackground rounded`}>
                    Release Notes
                </div>
                <div
                    className={`flex flexgrow horizontal releasenotes-flexrootcontainer`}
                >
                    <Box
                        className={`greybackground rounded releasenotes-flexcolumn groupcolumn-collapsed-${this.state.collapseGroups}`}
                    >
                        {this.state.collapseGroups ? (
                            <SearchIcon
                                className={`releasenotes-searchicon`}
                                onClick={this._handelUncollapseButtonClick}
                            />
                        ) : (
                            <div
                                style={{
                                    display: `flex`,
                                    flexDirection: `row`,
                                }}
                            >
                                <SearchField
                                    onChange={this._updateSearchText}
                                    onClearSearch={this._clearSearchText}
                                    value={this.state.searchText}
                                />
                                <div
                                    className={`releasenotes-collapsebutton`}
                                    onClick={this._handelCollapseButtonClick}
                                >
                                    <img
                                        alt={`&lt;`}
                                        className={`backbutton-icon`}
                                        src={`/Images/BackIcon.svg`}
                                    />
                                </div>
                            </div>
                        )}
                        {this.state.collapseGroups ? (
                            ``
                        ) : (
                            <div className={`releasenotes-linebreak`} />
                        )}
                        {this.state.searchText.length > 0 ? (
                            <SearchResults
                                searchResults={this.state.searchResults}
                            />
                        ) : (
                            <ApplicationGroups
                                collapseGroups={this.state.collapseGroups}
                                groups={this.state.groups}
                                handleGroupClick={this._handleGroupClick}
                                selectedGroup={this.state.selectedGroup}
                            />
                        )}
                    </Box>
                    <Box
                        className={`greybackground rounded releasenotes-flexcolumn applicationcolumn`}
                    >
                        <Applications
                            applications={this.state.applications}
                            handleApplicationClick={
                                this._handleApplicationClick
                            }
                            selectedApplication={this.state.selectedApplication}
                            selectedGroup={this.state.selectedGroup}
                        />
                    </Box>
                    <Box
                        className={`greybackground rounded releasenotes-flexcolumn notecolumn`}
                    >
                        <Notes
                            applicationID={this.state.selectedApplication}
                            searchText={this.state.searchText}
                            updateSearchResults={this._updateSearchResults}
                        />
                    </Box>
                </div>
            </div>
        );
    }
}
